import { render, staticRenderFns } from "./day-detail.vue?vue&type=template&id=e15faf24&"
import script from "./day-detail.vue?vue&type=script&lang=js&"
export * from "./day-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports